import styled from "styled-components";
import { Color, Colors } from "./Colors";

export const Form = styled.form`
    grid-column: 1 / -1; 
    flex: auto;
    background-color: ${({$theme}) => (($theme === 'lightBlue') ? Color(Colors.lightBlue) : Color(Colors.blue))}; 
    border-radius: 4px; 
    width: 100%;
    max-height: 1200px; 
    height: 100%; 
    padding: 1rem;  
    box-shadow: ${({$theme}) => (($theme === 'lightBlue') && `8px 8px 8px rgba(0, 0, 0, 0.3)`)}; 

    h5 {
        padding: 0 0 1rem 0; 
    }

    h5, 
    label {
        color: ${Color(Colors.white)}; 
    }
    

    input,
    textarea {
        background-color: ${({$theme}) => (($theme === 'lightBlue') ? Color(Colors.blue) : Color(Colors.lightBlue))};
        color: ${Color(Colors.white)};
        border: none;  
        margin: 1rem 0 1rem 0; 
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        color: ${Color(Colors.white)} !important; 
        -webkit-text-fill-color: ${Color(Colors.white)} !important;
        caret-color: ${Color(Colors.white)} !important; 
        -webkit-box-shadow: 0 0 0 1000px
            ${({$theme}) => 
                $theme === 'lightBlue' 
                    ? Color(Colors.blue) 
                    : Color(Colors.lightBlue)
            }
            inset !important; 
    }
        
    textarea::placeholder, 
    input::placeholder {
        color: rgba(255, 255, 255, 0.8);
    }
        
    input:focus,
    textarea:focus {
        outline: ${`2px solid ${Color(Colors.white)}`};  
    }

    input[type="datetime-local"]::-webkit-calendar-picker-indicator,
    input[type="date"]::-webkit-calendar-picker-indicator {
        filter: invert(1); 
    }
`;

export const ExpandTextArea = styled.div`
    position: relative; 
    display: inline-block; 
    width: 100%; 
    
    & > div {
        position: absolute;
        bottom: 28px; 
        right: 10px; 
        width: 16px;
        height: 16px; 
        cursor: se-resize;
        background-size: cover;
        background-image: url('/expand-icon.svg');  
        pointer-events: none; 
        transform: rotate(90deg); 
    }

    & > textarea {
        width: 100%; 
        white-space: pre-wrap;
        overflow-wrap: anywhere; 
        word-break: break-word; 
    }
`;